import React, { useState } from 'react';

const AIContentGenerator = ({handleAIEditorChange}) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const generateContent = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=AIzaSyB9FFU1SlkyXOPznYqjZ7_7LMxfVjTxIiE', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          contents: [
            {
              parts: [
                {
                  text: content,
                },
              ],
            },
          ],
        }),
      });

      const data = await response.json();
      if (response.ok) {
       
        const generatedContent = data.candidates[0].content.parts[0].text;
        handleAIEditorChange(generatedContent);
        //setContent(data.generatedContent); // Assume `generatedContent` is in the response
      } else {
        setError('Failed to generate content.');
      }
    } catch (err) {
      setError('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleContent=(e)=>{
    setContent(e.target.value);
  }
  return (
    <div>
        <input onChange={(e)=>handleContent(e)} className='p-2 mt-10 w-[50%]'></input>
      <button onClick={generateContent} disabled={loading} className='p-2 bg-blue-700  mt-10 text-white'>
        {loading ? 'Generating...' : 'Generate Description'}
      </button>
      {error && <p style={{ color: 'red' }}>{error}</p>}
     
    </div>
  );
};

export default AIContentGenerator;
